import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import Ws from '@adonisjs/websocket-client'
import WsPlugin from 'adonis-vue-websocket'
import store from './store'
import moment from 'moment'
import VueDragResize from 'vue-drag-resize'
import vueDebounce from 'vue-debounce'
import helper from './helper/helper';
Vue.component('vue-drag-resize', VueDragResize)
Vue.prototype.moment = moment
Vue.prototype.$helper = helper
Vue.config.productionTip = false
Vue.use(WsPlugin, { adonisWS: Ws })
Vue.use(vueDebounce)
new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
